import React from "react";
import { Modal, ModalBody } from 'reactstrap';
import CloseIcon from "web/assets/images/CloseIcon.png";
import { FlatFeeLisitngModalWrapper } from '../VendorPricingStyled'
import { flatFeeListingTableHeader } from "../Constants"

function FlatFeeLisitngModal(props) {
  const { flatFeeListData, closeModal } = props
  const { flatFeeList, otherDetails } = flatFeeListData

  const palletDetailsString = (data) => {
    let material = data?.material;
    let condition = data?.condition?.length !== 1 ? data?.condition?.join(", ") : data?.condition;
    let moisture = data?.moisture ? `, ${data?.moisture}` : "";
    let size = data?.size ? (data?.size === "Custom" ? `${data?.size}, ${data?.length}x${data?.width}x${data?.height}` : data?.size) : "";
    let grade = data?.grade ? `, ${data?.grade}` : "";
    let isHeatTreated = data?.heatTreared ? ", HT" : "";
    let palletType = data?.material === "WOOD" ? `, ${data?.palletType}` : "";
    let hardOrSoftWood = data?.newConditionType === "HARDWOOD" ? "(HW)" : (data?.newConditionType === "SOFTWOOD" ? "(SW)" : "");
    let LWH = data?.material !== "WOOD" ? `${data?.length}x${data?.width}x${data?.height}` : "";
    let truckPreference = otherDetails?.equipment

    if (data?.material !== "WOOD") {
      return condition ? `${material}, ${LWH} - ${condition}, ${truckPreference}` : `${material}, ${LWH}, ${truckPreference}`;
    } else {
      return `${size}${grade}${moisture}${isHeatTreated}${palletType} - ${condition || ""}${hardOrSoftWood}, ${truckPreference}`;
    }
  }

  return (
    <>
      <Modal isOpen={true} centered={true}>
        <FlatFeeLisitngModalWrapper>
          <ModalBody>
            <div className="main-header">
              <h4>Customer Flat Fee Rate Table</h4>
              <img src={CloseIcon} alt="close-icon" onClick={() => closeModal()} />
            </div>
            <div className="pallet-details-style">
              <p>Pallet Details :</p><span>{palletDetailsString(otherDetails?.palletDetails)}</span>
            </div>
            <div className="table-wrapper">
              <table>
                <thead>
                  <tr>
                    {flatFeeListingTableHeader?.map((data, index) => {
                      return (
                        <th key={index}>{data}</th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {flatFeeList?.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td>$ {parseFloat(data?.customerFee)?.toFixed(2)}</td>
                        <td>{data?.rateStartDate}</td>
                        <td>{data?.rateExpirationDate}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </ModalBody>
        </FlatFeeLisitngModalWrapper>
      </Modal>
    </>
  );
}

export default FlatFeeLisitngModal;
